import { Link } from 'react-router';

import { ACTIONS } from '../copy';
import { PATHS } from '../routes/paths';
import { useCurrentArea } from '../session';
import { AREA_HOME } from '../routes/paths';

/** A URL that is not part of the application. */
export function NotFoundPage() {
  const area = useCurrentArea();
  const home = area === null ? PATHS.login : AREA_HOME[area];

  return (
    <div className="page page--centred">
      <div className="notice">
        <h1 className="notice__title">Página não encontrada</h1>
        <p className="notice__body">
          O endereço que você abriu não existe. Ele pode ter mudado, ou o link pode estar
          incompleto.
        </p>
        <div className="notice__actions">
          <Link className="button button--primary" to={home}>
            {area === null ? ACTIONS.signIn : ACTIONS.goToMyArea}
          </Link>
        </div>
      </div>
    </div>
  );
}
